export default {
  registInfo: (state) => state.registInfo,
  cardInfo: (state) => state.cardInfo,
  formData: (state) => state.formData,
  cpmDetail: (state) => state.cpmDetail,
  delCardStatus: (state) => state.deleteCardStatus,
};
